import { BdcInvoiceSummary, BdcShipmentHeader } from "../../../types/bdc.type";

export interface ShipmentEvent {
  at: string;
  label: string;
  by: string | null;
  detail?: string;
  tone: "mut" | "info" | "warn" | "ok" | "crit";
}

/**
 * แท็บประวัติ — the milestones of one PO, newest first: นำเข้า, ยืนยัน DO (the latest one; the
 * server keeps no history of earlier confirms), each INV issued and each INV cancelled with its
 * reason. Delivery edits are listed separately (GET …/adjustments, paged).
 */
export const buildTimeline = (header: BdcShipmentHeader, invoices: BdcInvoiceSummary[]): ShipmentEvent[] => {
  const events: ShipmentEvent[] = [];
  if (header.imported_at) events.push({ at: header.imported_at, label: "นำเข้าไฟล์", by: null, tone: "mut" });
  if (header.do_confirmed_at) {
    events.push({ at: header.do_confirmed_at, label: "ยืนยัน DO", by: header.do_confirmed_by_name ?? null, tone: "info" });
  }
  invoices.forEach((inv) => {
    events.push({ at: inv.created_at, label: `ออก INV ${inv.invoice_no}`, by: inv.created_by_name, tone: "warn" });
    if (inv.status === "cancelled" && inv.cancelled_at) {
      events.push({
        at: inv.cancelled_at,
        label: `ยกเลิก INV ${inv.invoice_no}`,
        by: inv.cancelled_by_name,
        detail: inv.cancel_reason ?? undefined,
        tone: "crit",
      });
    }
  });
  return events.sort((a, b) => b.at.localeCompare(a.at));
};
